import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { CookieBanner, TornaHome } from "@/components/CookieBanner";
import AuthCallback from "@/components/AuthCallback";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import PraticaDetail from "@/pages/PraticaDetail";
import TaskBoard from "@/pages/TaskBoard";
import Team from "@/pages/Team";
import Bando from "@/pages/Bando";
import AreaRuolo from "@/pages/AreaRuolo";
import Presentazione from "@/pages/Presentazione";
import Landing from "@/pages/Landing";
import Home from "@/pages/Home";
import OnboardingStato from "@/pages/OnboardingStato";
import Settore from "@/pages/Settore";
import CasoStudio from "@/pages/CasoStudio";
import GuideVideo from "@/pages/GuideVideo";
import Social from "@/pages/Social";
import Incentivo from "@/pages/Incentivo";
import PercheBeaichy from "@/pages/PercheBeaichy";
import RegistraImpresa from "@/pages/RegistraImpresa";
import ServiziEsterni from "@/pages/ServiziEsterni";
import AreaPartner from "@/pages/AreaPartner";
import CasiSuccesso from "@/pages/CasiSuccesso";
import CasoSlide from "@/pages/CasoSlide";
import Fornitore from "@/pages/Fornitore";
import ImpresaArea from "@/pages/ImpresaArea";
import FinanzaAgevolata from "@/pages/FinanzaAgevolata";
import IncentiviLuogo from "@/pages/IncentiviLuogo";
import IncentiviLuogoSettore from "@/pages/IncentiviLuogoSettore";
import Risposta from "@/pages/Risposta";
import Sondaggio from "@/pages/Sondaggio";
import AreaRiservata from "@/pages/AreaRiservata";
import RegistraProfessionista from "@/pages/RegistraProfessionista";
import ProfessionistaArea from "@/pages/ProfessionistaArea";
import ReteProfessionisti from "@/pages/ReteProfessionisti";
import Valuta from "@/pages/Valuta";
import SchedaProfessionista from "@/pages/SchedaProfessionista";
import ChiSiamo from "@/pages/ChiSiamo";
import Confronto from "@/pages/Confronto";
import Preventivo from "@/pages/Preventivo";
import GestoreScheda from "@/pages/GestoreScheda";
import VerificaBandi from "@/pages/VerificaBandi";
import KitLegalePage from "@/pages/KitLegalePage";
import DashboardLegale from "@/pages/DashboardLegale";
import ProfiloTeam from "@/pages/ProfiloTeam";
import Associazioni from "@/pages/Associazioni";
import Simulatore from "@/pages/Simulatore";
import Osservatorio from "@/pages/Osservatorio";
import Normativa from "@/pages/Normativa";
import IterGara from "@/pages/IterGara";
import Regione from "@/pages/Regione";
import SportelloBando from "@/pages/SportelloBando";
import FasiComuni from "@/pages/FasiComuni";
import RadarBandi from "@/pages/RadarBandi";
import CheckIso from "@/pages/CheckIso";
import ConfrontoServizi from "@/pages/ConfrontoServizi";
import Istituzionale from "@/pages/Istituzionale";
import PerIComuni from "@/pages/PerIComuni";
import GuidaBando from "@/pages/GuidaBando";
import Indennizzo from "@/pages/Indennizzo";
import PerCommercialisti from "@/pages/PerCommercialisti";
import StrategiaBalneare from "@/pages/StrategiaBalneare";
import StrategiaSlide from "@/pages/StrategiaSlide";
import IncentiviTerritorio from "@/pages/IncentiviTerritorio";
import VerificaCompatibilita from "@/pages/VerificaCompatibilita";
import FirmaRemota from "@/pages/FirmaRemota";
import Legal from "@/pages/Legal";
import Gestione from "@/pages/Gestione";
import CasoPubblico from "@/pages/CasoPubblico";
import CasiStudio, { CasoStudio as CasoStudioPubblico } from "@/pages/CasiStudio";
import Bandi from "@/pages/Bandi";
import Comune from "@/pages/Comune";
import StudioAcquisto from "@/pages/StudioAcquisto";
import StabilimentoPagina from "@/pages/StabilimentoPagina";
import ImpresaPagina from "@/pages/ImpresaPagina";
import NonTrovata from "@/pages/NonTrovata";
import CatalogoIncentivi from "@/pages/CatalogoIncentivi";
import NewsletterStop from "@/pages/NewsletterStop";
import AreaCliente from "@/pages/AreaCliente";
import DataRoom from "@/pages/DataRoom";
import Screening from "@/pages/Screening";
import ScreeningAcquisto from "./pages/ScreeningAcquisto";
import Abbonamento, { AbbonamentoSuccesso } from "./pages/Abbonamento";

function AppRouter() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash && location.hash !== "#" && !location.hash.includes("session_id=")) {
      const t = setTimeout(() => document.getElementById(location.hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 300);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/onboarding/:id" element={<OnboardingStato />} />
      <Route path="/stabilimenti-balneari" element={<Landing />} />
      <Route path="/settore/:slug" element={<Settore />} />
      <Route path="/incentivo/:slug" element={<Incentivo />} />
      <Route path="/perche-beaichy" element={<PercheBeaichy />} />
      <Route path="/registrati" element={<RegistraImpresa />} />
      <Route path="/servizi-esterni" element={<ServiziEsterni />} />
      <Route path="/partner/:token" element={<AreaPartner />} />
      <Route path="/casi-di-successo" element={<CasiSuccesso />} />
      <Route path="/casi-di-successo/slide/:key" element={<CasoSlide />} />
      <Route path="/fornitore/:token" element={<Fornitore />} />
      <Route path="/impresa/:token" element={<ImpresaArea />} />
      <Route path="/finanza-agevolata" element={<FinanzaAgevolata />} />
      <Route path="/incentivi-imprese" element={<IncentiviTerritorio />} />
      <Route path="/strategia-balneare" element={<StrategiaBalneare />} />
      <Route path="/partnership" element={<StrategiaBalneare />} />
      <Route path="/strategia-balneare/slide/:n" element={<StrategiaSlide />} />
      <Route path="/incentivi-imprese/:slug" element={<IncentiviLuogo />} />
      <Route path="/incentivi-imprese/:slug/:settore" element={<IncentiviLuogoSettore />} />
      <Route path="/risposta/:cid" element={<Risposta />} />
      <Route path="/s/:id" element={<Sondaggio />} />
      <Route path="/area-riservata" element={<AreaRiservata />} />
      <Route path="/accesso/:token" element={<AreaRiservata />} />
      <Route path="/registrati-professionista" element={<RegistraProfessionista />} />
      <Route path="/professionista/:token" element={<ProfessionistaArea />} />
      <Route path="/rete-professionisti" element={<ReteProfessionisti />} />
      <Route path="/valuta/:token" element={<Valuta />} />
      <Route path="/professionisti/:slug" element={<SchedaProfessionista />} />
      <Route path="/chi-siamo" element={<ChiSiamo />} />
      <Route path="/beaichy-vs-gestionali-spiaggia" element={<Confronto />} />
      <Route path="/preventivo/:token" element={<Preventivo />} />
      <Route path="/gestore/scheda/:sid" element={<GestoreScheda />} />
      <Route path="/sondaggio/:id" element={<Sondaggio />} />
      <Route path="/associazioni" element={<Associazioni />} />
      <Route path="/simulatore-punteggio" element={<Simulatore />} />
      <Route path="/osservatorio-gare-balneari" element={<Osservatorio />} />
      <Route path="/radar-bandi" element={<RadarBandi />} />
      <Route path="/radar-bandi/:regione" element={<RadarBandi />} />
      <Route path="/normativa-concessioni-balneari" element={<Normativa />} />
      <Route path="/comuni/iter-gara" element={<IterGara />} />
      <Route path="/a-che-punto-sono-i-comuni" element={<FasiComuni />} />
      <Route path="/comuni/redigi-bando" element={<SportelloBando />} />
      <Route path="/comuni/:slug/redigi-bando" element={<SportelloBando />} />
      <Route path="/comuni/bozza/:id" element={<SportelloBando />} />
      <Route path="/regione/:slug" element={<Regione />} />
      <Route path="/check-iso-13009-bandiera-blu" element={<CheckIso />} />
      <Route path="/confronto-servizi-concessioni-balneari" element={<ConfrontoServizi />} />
      {["/team", "/codice-etico", "/accessibilita", "/sicurezza", "/stato-servizio"].map((r) => <Route key={r} path={r} element={<Istituzionale />} />)}
      <Route path="/per-i-comuni" element={<PerIComuni />} />
      <Route path="/guida-bando-tipo-concessioni-balneari" element={<GuidaBando />} />
      <Route path="/calcolatore-indennizzo" element={<Indennizzo />} />
      <Route path="/per-commercialisti" element={<PerCommercialisti />} />
      <Route path="/verifica-compatibilita" element={<VerificaCompatibilita />} />
      <Route path="/screening" element={<Screening />} />
      <Route path="/screening/:token/acquisto" element={<ScreeningAcquisto />} />
      <Route path="/report-360" element={<ProtectedRoute><Screening interno /></ProtectedRoute>} />
      <Route path="/report-360/:token" element={<ProtectedRoute><Screening interno /></ProtectedRoute>} />
      <Route path="/abbonamento/successo" element={<AbbonamentoSuccesso />} />
      <Route path="/abbonamento/:id" element={<Abbonamento />} />
      <Route path="/screening/:token" element={<Screening />} />
      <Route path="/login" element={<Login />} />
      <Route path="/firma/:token" element={<FirmaRemota />} />
      <Route path="/legal/:pagina" element={<Legal />} />
      <Route path="/caso/bagno-aurora" element={<CasoPubblico />} />
      <Route path="/casi-studio" element={<CasiStudio />} />
      <Route path="/caso-studio/:slug" element={<CasoStudioPubblico />} />
      <Route path="/bandi" element={<Bandi />} />
      <Route path="/comune/:slug" element={<Comune />} />
      <Route path="/studio/:sid" element={<StudioAcquisto />} />
      <Route path="/stabilimento/:comune/:slug" element={<StabilimentoPagina />} />
      <Route path="/impresa/:comune/:slug" element={<ImpresaPagina />} />
      <Route path="/incentivi" element={<CatalogoIncentivi />} />
      <Route path="/newsletter/stop/:token" element={<NewsletterStop />} />
      <Route path="/cliente/:token" element={<AreaCliente />} />
      <Route path="/dataroom/:token" element={<DataRoom />} />
      <Route path="/gestione" element={<ProtectedRoute><Gestione /></ProtectedRoute>} />
      <Route path="/gestione/bandi-verifica" element={<ProtectedRoute><VerificaBandi /></ProtectedRoute>} />
      <Route path="/verifica-bandi" element={<ProtectedRoute><VerificaBandi /></ProtectedRoute>} />
      <Route path="/gestione/kit-legale" element={<ProtectedRoute><KitLegalePage /></ProtectedRoute>} />
      <Route path="/legale" element={<ProtectedRoute><DashboardLegale /></ProtectedRoute>} />
      <Route path="/profilo" element={<ProtectedRoute><ProfiloTeam /></ProtectedRoute>} />
      <Route path="/caso-studio" element={<ProtectedRoute><CasoStudio /></ProtectedRoute>} />
      <Route path="/guide-video" element={<ProtectedRoute><GuideVideo /></ProtectedRoute>} />
      <Route path="/social" element={<ProtectedRoute><Social /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/pratiche/:id" element={<ProtectedRoute><PraticaDetail /></ProtectedRoute>} />
      <Route path="/tasks" element={<ProtectedRoute><TaskBoard /></ProtectedRoute>} />
      <Route path="/team" element={<ProtectedRoute><Team /></ProtectedRoute>} />
      <Route path="/bando" element={<ProtectedRoute><Bando /></ProtectedRoute>} />
      <Route path="/aree" element={<ProtectedRoute><AreaRuolo /></ProtectedRoute>} />
      <Route path="/aree/:ruolo" element={<ProtectedRoute><AreaRuolo /></ProtectedRoute>} />
      <Route path="/presentazione" element={<ProtectedRoute><Presentazione /></ProtectedRoute>} />
      <Route path="*" element={<NonTrovata />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ThemeProvider>
            <AppRouter />
            <TornaHome />
            <CookieBanner />
            <Toaster position="top-right" richColors />
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
